import React, { useEffect, useState, useRef, Fragment } from 'react'
import {
    FullscreenOutlined
} from '@ant-design/icons'
import {
    Button,
    Row,
    Col,
    Input,
    Select,
    Tooltip,
    Form,
    DatePicker,
    Space,
    Tabs,
    Alert, message
} from 'antd'
import '@/static/style/basetable.less'
import _, { get } from 'lodash'
import '@ant-design/pro-table/dist/table.css'
import ProTable from '@ant-design/pro-table'
import { dateTypeOptions, getColumns, getSearchTabs } from './config'
import { fetchEnums } from '../common/api'
import { transferx0ToX0, toggleFullScreen } from '../common/utils'
import { fetchInvoiceMatchingList, updateMatchingStatus, invoiceMatchingExport } from './api'
import { getFormatDate, outputMoney, getSid, objToArr } from '@/public/utils'
import DateChoose from '@/compenents/newDateChoose'
import moment from 'moment'

const FormItem = Form.Item

const layout = {
    // labelCol: { span: 6 },
    // wrapperCol: { span: 23 }
}

const MatchedList = (props) => {
    const { sigoCompanys } = props
    const [form] = Form.useForm()
    const tableActionRef = useRef()
    const [enums, setEnums] = useState({})
    const [status, setStatus] = useState()
    const [data, setData] = useState({})
    const [searchParams, setSearchParams] = useState({
        page_no:1,
        page_size:10
    })
    const [dateArr, setDateArr] = useState([
        moment().startOf('day').subtract(89, 'days').valueOf(),
        moment().endOf('day').valueOf()
    ])

    // 查询
    const searchFun = async () => {
        const values = await form.validateFields()
        var start_date = _.get(dateArr, '0') ? _.get(dateArr, '0').valueOf() : null
        var end_date = _.get(dateArr, '1') ? _.get(dateArr, '1').valueOf() : null
        var params = {
            ...values,
            start_date,
            end_date,
            sid: getSid(),
        }
        setSearchParams(params)
        tableActionRef.current.reloadAndRest()
    }


    function getParams(param) {
        const params = {
            page_no: param.current,
            page_size: param.pageSize,
            query: {
                status: param.status,
                ...searchParams,
                sid: getSid(),
            }
        }
        if (params.query.status === 'all') {
            delete params.query.status
        }
        return params
    }

    // 表格数据重组
    const queryResource = async (param) => {
        const params = getParams(param)
        try {
            const {
                data = {},
                page_no = 1,
                page_size = 10,
            } = (await fetchInvoiceMatchingList(params)) || {}
            var result = get(data, 'data')
            setData(result.data)
            return {
                success: true,
                data: get(result, 'data.match_list'),
                current: page_no,
                pageSize: page_size,
                total: get(result, 'total_count')
            }
        } catch (e) {
            return { success: false }
        }
    }

    const refreshTable = () => {
        tableActionRef.current.reloadAndRest()
    }

    const reloadFun = () => {
        window.location.reload()
    }


    const exportExl = async () => {
        await invoiceMatchingExport(searchParams)
    }

    const cancellation = ({ match_id }) => {
        updateMatchingStatus({
            match_id,
            status: '05' // 05 作废
        }).then(res => {
            var data = get(res, 'data')
            message[data.code === 200 ? 'success' : 'error'](data.message)
            refreshTable()
        })
    }

    const getenums = async () => {
        try {
            const {
                data = {}
            } = (await fetchEnums()) || {}
            setEnums(transferx0ToX0(data))
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        getenums()
        searchFun()
    }, [])

    const timerChange = (arr) => {
        setDateArr(arr)
    }


    return (
        <div>
            <Form form={form} {...layout}>
                <section className='roundBorder'>
                    <Row>
                        <FormItem name="account_no" label='视客对账单号'>
                            <Input placeholder="请输入" allowClear   style={{width:250}}/>
                        </FormItem>
                        <span className='ml8'></span>
                        <FormItem name="match_id" label='票单关联号'>
                            <Input placeholder="请输入" allowClear/>
                        </FormItem>
                        <span className='ml16'></span>
                        <FormItem name="date_type" initialValue={1}>
                            <Select
                                allowClear
                                defaultValue={1}
                                style={{ width: 100 }}
                                options={dateTypeOptions}
                                optionFilterProp={'label'}
                            />
                        </FormItem>
                        <FormItem name="time">
                            <span className='mr12'></span>
                            <DateChoose
                                defaultValue={'ninetyDays'}
                                ifConvenient={true}
                                isStatus={true}
                                isClick={false}
                                ifshowClear={true}
                                time={true}
                                timerChange={timerChange}
                            />
                        </FormItem>
                        
                        <span>
                            <Button type="primary" onClick={searchFun} shape="round" className='ml12'>
                                查询
                            </Button>
                            <Button onClick={reloadFun} shape="round" className='ml8 mr8'>重置</Button>
                            <Button onClick={exportExl} shape="round">导出</Button>
                        </span>
                    </Row>
                    <Row>
                        {
                            get(sigoCompanys, 'length') > 1 &&
                            <FormItem name="buyer_no" label={<div style={{width:"82px",textAlign:'right'}}>结算主体</div>}>
                                <Select placeholder="请选择" allowClear  style={{width:250}}
                                    options={sigoCompanys} optionFilterProp={'label'} />
                            </FormItem>
                        }
                    </Row>
                </section>

                <div className='roundBorder mt24 pro_table_tab boldHeader componentsTable'>
                    <Alert message={
                        <Fragment>
                            <span style={{ fontSize: "14px" }}>
                                <span>发票金额合计：</span>
                                <span className={'redFont'}>
                                    {outputMoney(get(data, 'total_invoice_amount'))}
                                </span>
                                <span style={{ paddingRight: 12 }}>元</span>
                                <span>对账单金额合计：</span>
                                <span className={'redFont'}>
                                    {outputMoney(get(data, 'total_account_amount'))}
                                </span>
                                <span style={{ paddingRight: 12 }}>元</span>
                                <span>税票差异调整金额合计：</span>
                                <span className={'redFont'}>
                                    {outputMoney(get(data, 'total_adjust_amount'))}
                                </span>
                            </span>
                        </Fragment>
                    }>
                    </Alert>
                    <div style={{ position: "static" }}>
                        <ProTable
                            actionRef={tableActionRef}
                            rowKey={'match_id'}
                            pagination={{
                                current: get(searchParams,'page_no'),
                                pageSize: get(searchParams,'page_size'),
                                pageSizeOptions: [10, 20, 50, 80],
                                showQuickJumper: true,
                                showSizeChanger: true
                            }}
                            params={{ status }}
                            scroll={{ x: 1450 }}
                            search={false}
                            sticky={true}
                            toolbar={{
                                title: (
                                    <Tabs style={{width:'1000px'}} type="card" size={"small"} activeKey={status} onChange={(v) => {
                                        setStatus(v)
                                    }}>
                                        {getSearchTabs(data).map(item => {
                                            return (
                                                <Tabs.TabPane tab={get(item, 'label')} key={get(item, 'key')}>
                                                </Tabs.TabPane>
                                            )
                                        })}
                                    </Tabs>
                                ),
                                actions: [
                                    <Tooltip placement="top" title="全屏">
                                        <FullscreenOutlined
                                            style={{
                                                width: '1em',
                                                height: '1em',
                                                cursor: 'pointer',
                                                marginLeft: '10px'
                                            }}
                                            onClick={toggleFullScreen}
                                        />
                                    </Tooltip>
                                ]
                            }}
                            request={queryResource}
                            columns={getColumns({ enums, cancellation, sigoCompanys })}
                            tableAlertRender={false}
                            columnEmptyText="--"
                            options={true}
                        />
                    </div>
                </div>
            </Form>
        </div >
    )

}

export default MatchedList




// WEBPACK FOOTER //
// ./src/pages/billVerification/match/list/waitMatched.js